<template>
    <div class="d-flex flex-row flex-column-fluid page">
        <!--begin::Aside-->
        <Aside></Aside>
        <!--end::Aside-->
        <div class="d-flex flex-column flex-row-fluid wrapper pt-0" id="kt_wrapper">
            <div class="d-flex flex-column" style="min-height: 100vh;">
                <Toasts :firebase-uid="$page.props.auth_uid"/>
                <StoreHeader v-if="$page.props.store" :store="$page.props.store"/>

                <Card class="mx-5 mt-5">
                    <template v-slot:icon>
                        <i class="fas fa-chart-pie font-size-h2"/>
                    </template>
                    <template v-slot:title>
                        <h1 class="card-title"
                            v-html=" __('statistics.title', {'date': formatDate(filters.date.start, false) + ' - ' + formatDate(filters.date.end, false)})"></h1>
                    </template>
                    <template v-slot:description>
                        {{ __('statistics.description') }}
                    </template>

                    <div class="row align-items-baseline text-muted">
                        <i class="fas fa-filter mr-3 ml-4"></i>
                        <div class="text-lg font-italic font-weight-bold mb-4">{{
                                showCategoryFilter ? __('statistics.filter_bar_category') : __('statistics.filter_bar')
                            }}
                        </div>
                    </div>
                    <FilterBar>
                        <FilterDateRange :value="initFilters.date" @input="filters.date = $event"
                                         :has-daily-filter="hasDailyFilter"/>
                        <FilterCategory
                            v-if="showCategoryFilter && !selectableCategoriesIsEmpty"
                            class="ml-4"
                            v-model="filters.category"
                            :selectable-categories="selectableCategories"
                            :only-l1-categories="onlyL1Categories"
                        >
                        </FilterCategory>
                    </FilterBar>
                </Card>

                <TabbedStatisticsCard :init-filters="initFilters" @slotFilterChanged="slotFiltersChanged">
                    <div v-if="loading" class="text-3xl text-primary">
                        <spinner class="text-center pt-0 pb-6" :size="24"
                                 line-fg-color="#795BF3"/>
                    </div>

                    <slot></slot>

                </TabbedStatisticsCard>
                <PageFooter/>
            </div>
        </div>
    </div>
</template>

<script>
import Card from '@components/Cards/Card.vue';
import FilterBar from '@components/Stats/FilterBar.vue';
import FilterDateRange from '@components/Stats/Filters/FilterDateRange.vue';
import {rewriteUrlNew} from '@composables/rewriteUrlNew';
import Toasts from '@components/Toasts.vue';
import PageFooter from '@layouts/Includes/PageFooter.vue';
import FlashMessages from '@components/FlashMessages.vue';
import StoreHeader from '@components/Store/StoreHeader.vue';
import TabbedStatisticsCard from '@components/Stats/TabbedStatisticsCard.vue';
import Spinner from 'vue-simple-spinner';
import FilterCategory from '@components/Stats/Filters/FilterCategory.vue';
import Aside from '@components/Navigation/Aside.vue';

export default {
    components: {
        Aside,
        FilterCategory,
        TabbedStatisticsCard,
        StoreHeader,
        FlashMessages,
        PageFooter,
        Toasts,
        FilterDateRange,
        FilterBar,
        Card,
        Spinner,
    },
    props: {
        selectableCategories: [Object, Array],
        initFilters: {
            type: Object,
            default: {
                date: {
                    start: null,
                    end: null,
                },
                category: null,
                sources: [],
                priceSegmentFilter: null,
            },
        },
        hasDailyFilter: Boolean,
        showCategoryFilter: Boolean,
        onlyL1Categories: Boolean,
    },

    data() {
        return {
            filters: {...this.initFilters},
            loading: false,
        };
    },

    methods: {
        formatDate(dateTime, forRequest = true) {
            const date = new Date(dateTime);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');

            if (forRequest) {
                return `${year}-${month}-${day}`;
            }

            return `${day}.${month}.${year}`;
        },

        slotFiltersChanged(filter) {
            this.$set(this.filters, filter.field, filter.value);
        },
    },

    watch: {
        filters: {
            deep: true,
            handler(newValue, oldValue) {
                rewriteUrlNew('filter', newValue);
                this.loading = true;
                this.$inertia.reload({
                    only: [
                        'initFilters',
                        'mcSeriesImpressionsClicks',
                        'gmbSeries',
                        'statistics',
                        'selectableCategories'],
                    onStart: () => {
                        this.loading = true;
                    },
                    onFinish: () => {
                        this.loading = false;
                    },
                    replace: true,
                });
            },
        },
    },
    computed: {
        selectableCategoriesIsEmpty() {
            if (Array.isArray(this.selectableCategories)) {
                return this.selectableCategories.length === 0;
            } else if (this.selectableCategories && typeof this.selectableCategories === 'object') {
                return Object.keys(this.selectableCategories).length === 0;
            }
        },
    },
};
</script>
